const throttle = (func, delay) => {
  let timeoutId;
  let lastArgs;
  let lastThis;
  let lastResult;
  let lastExecutionTime = 0;

  return function (...args) {
    lastArgs = args;
    lastThis = this;

    const now = Date.now();
    const remainingTime = delay - (now - lastExecutionTime);

    if (remainingTime <= 0 || remainingTime > delay) {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      lastExecutionTime = now;
      lastResult = func.apply(lastThis, lastArgs);
    } else if (!timeoutId) {
      timeoutId = setTimeout(() => {
        lastExecutionTime = Date.now();
        timeoutId = null;
        lastResult = func.apply(lastThis, lastArgs);
      }, remainingTime);
    }
    return lastResult;
  };
};

export default throttle;
